<!-- Content Header (Page header) -->
<section class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1>Retiros y Despachos</h1>
            </div>
            <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                    <li class="breadcrumb-item"><a [routerLink]="['/']">Home</a></li>
                    <li class="breadcrumb-item active"><a href="pedidos.php">Pedidos</a></li>
                    <li class="breadcrumb-item active">Retiros y Despachos {{this.appService.user.app_driver}}</li>
                </ol>
            </div>
        </div>
    </div><!-- /.container-fluid -->
</section>

<!-- Main content -->
<section class="content container-fluid">
    <div class="row justify-content-center" *ngIf="this.appService.user.role != 'delivery'">
        <div class="col-xl-10 col-12">
            <div class="card">
                <div class="card-body">
                    <div class="row justify-content-center">
                        <div class="col-lg-6">
                            <a class="btn btn-outline-primary btn-block btn-lg" data-toggle="collapse" href="#addRetiro"
                                aria-expanded="false" aria-controls="addRetiro">
                                <i class="fas fa-shipping-fast"></i> Agregar retiro
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="collapse" id="addRetiro">
                <div class="card card-body">
                    <form [formGroup]="pedidoForm" *ngIf="pedidoForm">
                        <div class="row justify-content-center">
                            <div class="col-md-4">
                                <div class="row">
                                    <div class="col-md-9 pr-0">
                                        <app-typeahead idForm="InputCliente" [data]="clientes" size="lg"
                                            optField="nombre_completo" [autocomplete]="false" label="Cliente"
                                            placeholder="Selecciona un cliente"
                                            [control]="pedidoForm.get('nombre_cliente')"
                                            (onSelectItem)="onSelectItemCliente($event)"></app-typeahead>
                                        <input type="hidden" id="InputIdCliente" name="InputIdCliente"
                                            [formControl]="pedidoForm.get('id_cliente')" autocomplete="off">
                                    </div>
                                    <div class="col-md-3">
                                        <div class="pt-3 mt-3">
                                            <app-new-cliente (updateData)="getClientes()"
                                                [buttonOnlyIcon]="true"></app-new-cliente>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="row">
                                    <div class="col-md-9 pr-0">
                                        <app-select label="Dirección" idForm="InputDireccionPickup"
                                            [control]="pedidoForm.get('id_direccion_pickup')" [data]="listaDirecciones"
                                            optValue="id_direccion" size="lg" optText="direccion_completa"></app-select>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="pt-3 mt-3">
                                            <app-add-direccion [buttonOnlyIcon]="true" [id_cliente]="id_cliente"
                                                size="lg"
                                                (updateData)="updateDataDireccionPickup($event)"></app-add-direccion>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <app-datepicker idForm="InputFechaRetiro" cssClass="text-left" label="Fecha Retiro"
                                    placeholder="Ingresar Fecha" size="lg" [control]="pedidoForm.get('fecha_termino')"
                                    [bsValue]="pedidoForm.get('fecha_termino').value"></app-datepicker>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <button type="button" name="addProducto" (click)="saveRetiro(pedidoForm.value)"
                                    class="btn btn-outline-success btn-block btn-lg" [disabled]="!pedidoForm.valid">
                                    <i class="fas fa-angle-double-down"></i> Agregar
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-xl-10 col-12">
            <tabset #staticTabs>
                <tab heading="Diario" [active]="this.appService.user.role == 'delivery'"
                    *ngIf="this.appService.user.role != 'user'">
                    <div class="row justify-content-center">
                        <div class="col-12">
                            <div class="card">
                                <div class="row justify-content-center">
                                    <div class="col-xl-6">
                                        <app-datepicker idForm="InputFechaEntrega" size="lg" cssClass="text-center"
                                            *ngIf="deliveryForm" [control]="deliveryForm.get('fecha')"
                                            [bsValue]="deliveryForm.get('fecha').value"
                                            (valueChange)="findRetiros($event)" [hideIcon]="true"
                                            [activateButton]="true"></app-datepicker>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-12">
                            <div class="row" id="ListaPedidos">
                                <div class="col-xl-3 col-md-4 col-sm-6 col-12" *ngFor="let item of retiros">
                                    <div class="card card-outline"
                                        [ngClass]="item.id_estado == 2 ? 'card-orange' : 'card-lightblue'"
                                        style="min-height:260px">
                                        <div class="card-header">
                                            <h3 class="card-title text-bold  py-1">{{item.numero_pedido_format || item.id_pedido_format}}</h3>
                                            <div class="card-tools" *ngIf="this.appService.user.role != 'delivery'">
                                                <button type="button" name="next" class="btn btn-link btn-sm"><i
                                                        class="fas fa-edit text-dark"
                                                        *ngIf="this.appService.user.role != 'delivery'"
                                                        (click)="EditaPedido(item.id_pedido)"></i></button>
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-12 border-bottom"
                                                    *ngIf="item.id_estado == 2 && item.is_pickup">
                                                    <span class="row item-info"><i
                                                            class="col-2 fs-16 fas fa-shipping-fast py-1 text-center"></i>
                                                        <div class="col-10 row">Retiro</div>
                                                    </span>
                                                </div>
                                                <div class="col-12 border-bottom"
                                                    *ngIf="item.id_estado == 4 && item.is_delivery">
                                                    <span class="row item-info"><i
                                                            class="col-2 fs-16 fas fa-shipping-fast py-1 text-center"></i>
                                                        <div class="col-10 row">Despacho</div>
                                                    </span>
                                                </div>
                                                <div class="col-12 border-bottom"
                                                    *ngIf="item.id_estado == 2 && item.is_pickup">
                                                    <span class="row item-info"><i
                                                            class="col-2 fs-16 fas fa-calendar-day py-1 text-center"></i>
                                                        <div class="col-10 row">{{ item.fecha_pickup | date:
                                                            'dd/MM/yyy'}}</div>
                                                    </span>
                                                </div>
                                                <div class="col-12 border-bottom"
                                                    *ngIf="item.id_estado == 4 && item.is_delivery">
                                                    <span class="row item-info"><i
                                                            class="col-2 fs-16 fas fa-calendar-day py-1 text-center"></i>
                                                        <div class="col-10 row">{{ item.fecha_delivery | date:
                                                            'dd/MM/yyy'}}
                                                        </div>
                                                    </span>
                                                </div>
                                                <div class="col-12 border-bottom" *ngIf="item.cliente.nombre_completo">
                                                    <span class="row item-info"><i
                                                            class="col-2 fs-16 fas fa-user py-1 text-center"></i>
                                                        <div class="col-10 row">{{item.cliente.nombre_completo}}</div>
                                                    </span>
                                                </div>
                                                <div class="col-12 border-bottom" *ngIf="item.cliente.telefono">
                                                    <span class="row item-info"><i
                                                            class="col-2 fs-16 fas fa-phone py-1 text-center"></i>
                                                        <div class="col-10 row">{{item.cliente.telefono}}</div>
                                                    </span>
                                                </div>
                                                <div class="col-12 border-bottom"
                                                    *ngIf="item.id_estado == 2 && item.is_pickup">
                                                    <span class="row item-info">
                                                        <i
                                                            class="col-2 fs-16 fas fa-map-marker-alt py-1 text-center"></i>
                                                        <div class="col-10 row">{{item.direccion_pickup.direccion}},
                                                            {{item.direccion_pickup.detalle == "" ||
                                                            item.direccion_pickup.detalle == null ? "" :
                                                            item.direccion_pickup.detalle + "," }}
                                                            {{item.direccion_pickup.comuna_nombre}}</div>
                                                    </span>
                                                </div>
                                                <div class="col-12 border-bottom"
                                                    *ngIf="item.id_estado == 4 && item.is_delivery">
                                                    <span class="row item-info">
                                                        <i
                                                            class="col-2 fs-16 fas fa-map-marker-alt py-1 text-center"></i>
                                                        <div class="col-10 row">{{item.direccion_delivery.direccion}},
                                                            {{item.direccion_delivery.detalle == "" ||
                                                            item.direccion_delivery.detalle == null ? "" :
                                                            item.direccion_delivery.detalle + ","}}
                                                            {{item.direccion_delivery.comuna_nombre}}</div>
                                                    </span>
                                                </div>
                                                <div class="col-12 border-bottom" *ngIf="item.productos">
                                                    <span class="row item-info"><i
                                                            class="col-2 fs-16 fas fa-tshirt py-1 text-center"></i>
                                                        <div class="col-10 row" [innerHTML]="item.productos"></div>
                                                    </span>
                                                </div>
                                                <div class="col-12 border-bottom" *ngIf="item.observacion">
                                                    <span class="row item-info"><i
                                                            class="col-2 fs-16 fas fa-comment-dots py-1 text-center"></i>
                                                        <div class="col-10 row">{{item.observacion}}</div>
                                                    </span>
                                                </div>
                                                <div class="col-12 border-bottom" *ngIf="item.saldo">
                                                    <span class="row item-info"><i
                                                            class="col-2 fs-16 fas fa-comment-dollar  py-1 text-center"></i>
                                                        <div class="col-10 row">{{Func.currencyPeso(item.saldo)}}</div>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-footer footer-user"
                                            style="display: flex; justify-content:space-around">
                                            <a class='btn btn-outline-info' *ngIf="item.cliente.telefono"
                                                href='tel:{{item.cliente.telefono}}' target='_blank'><i
                                                    class='fas fa-phone-volume'></i></a>
                                            <a class='btn btn-outline-success' *ngIf="item.cliente.telefono"
                                                href='{{item.cliente.whatsapp}}' target='_blank'><i
                                                    class='fab fa-whatsapp'></i></a>
                                            <!-- <a class='btn btn-outline-danger'
                                                        *ngIf="item.id_estado == 2 && item.is_pickup"
                                                        href='https://www.google.cl/maps/place/{{item.direccion_pickup}},+{{item.comuna_nombre_pickup}},+{{item.provincia_nombre_pickup}},+{{item.region_nombre_pickup}}'
                                                        target='_blank'><i class='fas fa-map-marked-alt'></i></a>
                                                    <a class='btn btn-outline-danger'
                                                        *ngIf="item.id_estado == 4 && item.is_delivery"
                                                        href='https://www.google.cl/maps/place/{{item.direccion_delivery}},+{{item.comuna_nombre_delivery}},+{{item.provincia_nombre_delivery}},+{{item.region_nombre_delivery}}'
                                                        target='_blank'><i class='fas fa-map-marked-alt'></i></a> -->
                                            <a class='btn btn-outline-danger' (click)="abrirNavegacion(item)"><i
                                                    class='fas fa-map-marked-alt'></i></a>
                                            <app-modal-cambia-estado cssClass="first-element"
                                                [idPedido]="item.id_pedido" [estadoOld]="item.id_estado"
                                                [estadoOldText]="item.estado.nombre_estado"
                                                [estadoNew]="item.estado.next_estado"
                                                (updateData)="findRetiros(dateSelected)"></app-modal-cambia-estado>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </tab>
                <tab heading="Todo" [active]="this.appService.user.role != 'delivery'">
                    <div class="card card-body table-responsive p-0">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th class="text-center"><i class="fas fa-file-alt"></i> Pedido</th>
                                    <th class="text-center"><i class="fas fa-shipping-fast"></i> Tipo</th>
                                    <th class="text-center"><i class="fas fa-calendar-day"></i> Fecha</th>
                                    <th class="text-center"><i class="fas fa-user"></i> Cliente</th>
                                    <!-- <th class="text-center"><i class="fas fa-tshirt"></i> Productos</th> -->
                                    <th class="text-center"><i class="fas fa-comment-dots"></i> Comentarios</th>
                                    <th class="text-center"><i class="fas fa-comment-dollar"></i> Saldo</th>
                                    <th> </th>
                                </tr>
                            </thead>
                            <tbody *ngFor="let item of rows; let rowIndex = index">
                                <tr>
                                    <td>
                                        <button class="btn btn-link" (click)="openDetail(rowIndex)">
                                            <i class="fas fa-chevron-right" *ngIf="!this.isExpanded[rowIndex]"></i>
                                            <i class="fas fa-chevron-down"
                                                *ngIf="this.isExpanded[rowIndex]"></i></button>
                                    </td>
                                    <td>{{item.numero_pedido_format || item.id_pedido_format}}</td>
                                    <td>
                                        <span *ngIf="item.id_estado == 2 && item.is_pickup">Retiro</span>
                                        <span *ngIf="item.id_estado == 4 && item.is_delivery">Despacho</span>
                                    </td>
                                    <td>
                                        <span *ngIf="item.id_estado == 2 && item.is_pickup">{{item.fecha_pickup | date:
                                            'dd/MM/yyy'}}</span>
                                        <span *ngIf="item.id_estado == 4 && item.is_delivery">{{item.fecha_delivery |
                                            date:
                                            'dd/MM/yyy'}}</span>
                                    </td>
                                    <td><span
                                            *ngIf="item.cliente.nombre_completo">{{item.cliente.nombre_completo}}</span>
                                    </td>
                                    <!-- <td>
                                        <div *ngIf="item.productos" [innerHTML]="item.productos"></div>
                                    </td> -->
                                    <td><span *ngIf="item.observacion">{{item.observacion}}</span></td>
                                    <td><span *ngIf="item.saldo">{{Func.currencyPeso(item.saldo)}}</span></td>
                                    <td style='width: 150px'>
                                        <div class="btn-group">
                                            <a class='btn btn-outline-info' *ngIf="item.cliente.telefono"
                                                href='tel:{{item.cliente.telefono}}' target='_blank'><i
                                                    class='fas fa-phone-volume'></i></a>
                                            <a class='btn btn-outline-success' *ngIf="item.cliente.telefono"
                                                href='{{item.cliente.whatsapp}}' target='_blank'><i
                                                    class='fab fa-whatsapp'></i></a>
                                            <!-- <a class='btn btn-outline-danger'
                                                *ngIf="item.id_estado == 2 && item.is_pickup"
                                                href='https://www.google.cl/maps/place/{{item.direccion_pickup}},+{{item.comuna_nombre_pickup}},+{{item.provincia_nombre_pickup}},+{{item.region_nombre_pickup}}'
                                                target='_blank'><i class='fas fa-map-marked-alt'></i></a>
                                            <a class='btn btn-outline-danger'
                                                *ngIf="item.id_estado == 4 && item.is_delivery"
                                                href='https://www.google.cl/maps/place/{{item.direccion_delivery}},+{{item.comuna_nombre_delivery}},+{{item.provincia_nombre_delivery}},+{{item.region_nombre_delivery}}'
                                                target='_blank'><i class='fas fa-map-marked-alt'></i></a> -->
                                            <a class='btn btn-outline-danger' (click)="abrirNavegacion(item)"><i
                                                    class='fas fa-map-marked-alt'></i></a>
                                            <app-modal-cambia-estado cssClass="middle-element"
                                                [idPedido]="item.id_pedido" [estadoOld]="item.id_estado"
                                                [estadoOldText]="item.estado.nombre_estado"
                                                [estadoNew]="item.estado.next_estado"
                                                (updateData)="getData()"></app-modal-cambia-estado>
                                            <button type="button" class="btn btn-outline-info btn-sm last-element"
                                                title="Ver" (click)="EditaPedido(item.id_pedido)"
                                                *ngIf="this.appService.user.role != 'delivery'">
                                                <i class='fas fa-edit'></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                                <tr *ngIf="isExpanded[rowIndex]">
                                    <td colspan="8">
                                        <div class="row justify-content-center">
                                            <div class="col-md-5">
                                                <div class="row">
                                                    <div class="col-12 " *ngIf="item.cliente.telefono">
                                                        <span class="row item-info"><i
                                                                class="col-2 fs-16 fas fa-phone py-1 text-center"></i>
                                                            <div class="col-10 row">{{item.cliente.telefono}}</div>
                                                        </span>
                                                    </div>
                                                    <div class="col-12 " *ngIf="item.id_estado == 2 && item.is_pickup">
                                                        <span class="row item-info">
                                                            <i
                                                                class="col-2 fs-16 fas fa-map-marker-alt py-1 text-center"></i>
                                                            <div class="col-10 row">{{item.direccion_pickup.direccion}},
                                                                {{item.direccion_pickup.detalle == "" ||
                                                                item.direccion_pickup.detalle == null ? "" :
                                                                item.direccion_pickup.detalle + "," }}
                                                                {{item.direccion_pickup.comuna_nombre}}</div>
                                                        </span>
                                                    </div>
                                                    <div class="col-12 "
                                                        *ngIf="item.id_estado == 4 && item.is_delivery">
                                                        <span class="row item-info">
                                                            <i
                                                                class="col-2 fs-16 fas fa-map-marker-alt py-1 text-center"></i>
                                                            <div class="col-10 row">
                                                                {{item.direccion_delivery.direccion}},
                                                                {{item.direccion_delivery.detalle == "" ||
                                                                item.direccion_delivery.detalle == null ? "" :
                                                                item.direccion_delivery.detalle + ","}}
                                                                {{item.direccion_delivery.comuna_nombre}}</div>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-5">
                                                <div class="row">
                                                    <div class="col-12" *ngIf="item.productos">
                                                        <span class="row item-info"><i
                                                                class="col-2 fs-16 fas fa-tshirt py-1 text-center"></i>
                                                            <div class="col-10 row" [innerHTML]="item.productos"></div>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </tab>
            </tabset>
        </div>
    </div>
</section>